import React from 'react';
import { useParams } from 'react-router';
import { Button, Row } from 'antd';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { PageContainer } from '@ant-design/pro-layout';
import { PlusOutlined } from '@ant-design/icons';
import ProjectHeader from '../../ProjectHeader';
import { GET_WITHDRAWALS } from '../../../../gql/withdrawals';
import WithdrawalsTable from './components/WithdrawalsTable';
import PrivateComponentInProject from '../../../auth/PrivateComponentInProject';
import { useProjectFrozen } from 'hooks';

const Withdrawals = () => {
  const { projectId } = useParams();
  const projectFrozen = useProjectFrozen(projectId);
  const { data, loading } = useQuery(GET_WITHDRAWALS, {
    variables: {
      projectIds: [projectId],
      status: ['DRAFT', 'PENDING', 'REJECTED', 'APPROVED', 'VOIDED'],
    },
  });

  return (
    <ProjectHeader>
      <PageContainer title="Withdrawal" loading={loading}>
        {!projectFrozen && (
          <Row>
            <PrivateComponentInProject expectedScopeType={['WRITE_WITHDRAWAL']}>
              <Link to={`/projects/${projectId}/withdrawals/add`}>
                <Button type="primary" icon={<PlusOutlined />}>
                  Apply for withdrawal
                </Button>
              </Link>
            </PrivateComponentInProject>
          </Row>
        )}
        <WithdrawalsTable withdrawals={data?.withdrawals} />
      </PageContainer>
    </ProjectHeader>
  );
};

export default Withdrawals;
